import { render, staticRenderFns } from "./system-log.vue?vue&type=template&id=2531b81e&scoped=true&"
import script from "./system-log.vue?vue&type=script&lang=js&"
export * from "./system-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531b81e",
  null
  
)

export default component.exports